import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the orderTreatment state domain
 */

const selectOrderTreatmentDomain = state =>
  state.get("orderTreatment", initialState);

/**
 * Other specific selectors
 */
const makeSelectOrderTreatmentLoading = () =>
  createSelector(selectOrderTreatmentDomain, substate =>
    substate.get("loading"),
  );

const makeSelectOrderTreatmentError = () =>
  createSelector(selectOrderTreatmentDomain, substate => substate.get("error"));

const makeSelectOrderTreatmentPatient = () =>
  createSelector(selectOrderTreatmentDomain, substate =>
    substate.get("patient"),
  );

const makeSelectOrderTreatmentDentists = () =>
  createSelector(
    selectOrderTreatmentDomain,
    substate => substate.toJS().dentists || [],
  );

const makeSelectOrderTreatmentInsurers = () =>
  createSelector(
    selectOrderTreatmentDomain,
    substate => substate.toJS().insurers || [],
  );
const makeSelectOrderTreatmentProductPlan = () =>
  createSelector(selectOrderTreatmentDomain, substate =>
    substate.get("productPlan"),
  );

const makeSelectOrderTreatmentActiveOrderId = () =>
  createSelector(selectOrderTreatmentDomain, substate =>
    substate.get("activeOrderId"),
  );

const makeSelectOrderTreatmentCanContinue = () =>
  createSelector(selectOrderTreatmentDomain, substate =>
    substate.get("canContinue"),
  );

/**
 * Default selector used by OrderTreatment
 */

const makeSelectOrderTreatment = () =>
  createSelector(selectOrderTreatmentDomain, substate => substate.toJS());

export default makeSelectOrderTreatment;
export {
  selectOrderTreatmentDomain,
  makeSelectOrderTreatmentLoading,
  makeSelectOrderTreatmentError,
  makeSelectOrderTreatmentPatient,
  makeSelectOrderTreatmentDentists,
  makeSelectOrderTreatmentInsurers,
  makeSelectOrderTreatmentProductPlan,
  makeSelectOrderTreatmentActiveOrderId,
  makeSelectOrderTreatmentCanContinue,
};
